import React, { useState } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { useMutation, ApolloError } from '@apollo/client';
import { useIntl } from 'react-intl';
import ResetPasswordFormComponent
  from '@fuww/library/src/Users/ResetPasswordForm';
import ServerValidation from '../ServerValidation';
import sendResetEmailMutation
  from '../../lib/mutations/sendResetPasswordEmail.graphql';
import { useSiteContext } from '../SiteContext';
import messages from '../../lib/messages.json';
import Routes from '../../routes.mjs';

const resetPasswordFormPropertyTypes = {
  setChangeSuccess: PropTypes.func.isRequired,
};

// eslint-disable-next-line @stylistic/max-len
type ResetPasswordFormProperties = InferProps<typeof resetPasswordFormPropertyTypes>;

const ResetPasswordForm = ({
  setChangeSuccess,
}: ResetPasswordFormProperties) => {
  const intl = useIntl();
  const { origin } = useSiteContext();

  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [submitErrors, setSubmitErrors] = useState<ApolloError | null>(null);
  const changePasswordUrl = `${origin}${
    Routes.findAndGetUrls('change-password').urls.as
  }`;

  const [
    sendResetEmail,
  ] = useMutation(sendResetEmailMutation, {
    onCompleted: () => {
      setSubmitDisabled(false);
      setChangeSuccess(true);
    },
    onError: (error) => {
      setSubmitDisabled(false);
      setSubmitErrors(error);
    },
  });

  const submitHandler = ({ email }: { email: string }) => {
    setSubmitDisabled(true);
    sendResetEmail({
      variables: {
        email,
        url: changePasswordUrl,
      },
    });
  };

  return (
    <ResetPasswordFormComponent
      emailAddressLabel={intl.formatMessage(
        messages['resetPassword.enterEmail'],
      )}
      requiredValidationMessage={intl.formatMessage(
        messages['applicantForm.fieldRequired'],
      )}
      emailValidationMessage={intl.formatMessage(messages[
        'applicantForm.mustBeValidEmailAddress'
      ])}
      submitLabel={intl.formatMessage(messages['resetPassword.sendLink'])}
      submitHandler={submitHandler}
      serverValidation={submitErrors ? (
        <ServerValidation errors={submitErrors} />
      ) : null}
      submitDisabled={submitDisabled}
    />
  );
};

ResetPasswordForm.propTypes = resetPasswordFormPropertyTypes;

export default ResetPasswordForm;
